import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "modal" ];
  static classes = ["open"];
  modal() {
    this.modalTarget.classList.toggle(this.openClass);
  }

}
